import React, { useEffect } from "react";
import ButtonT from "../../components/atoms/ButtonT";
import InputGroup from "../../components/atoms/InputGroup";
import Title from "../../components/atoms/Title";
import TitleDetail from "../../components/atoms/TitleDetail";
import Navbar from "../../components/main/Navbar";
import { useStateContext } from "../../context/AdminDashboard/ModelsAddEditContext";
import SelectModal from "../../components/atoms/SelectModal";
import { Toaster } from "react-hot-toast";
import ParentComponent from "../../components/deviceModels/Dynamic";
import NumberInputWithCommas from "../../components/deviceModels/InputPrice";
import Loading from "../../components/atoms/Loading";

const ModelEdit = () => {
  const {
    changeConnection,
    onchangeInput,
    changehealthrules,
    changeenvironment,
    changeuseType,
    changetestType,
    changeprotocol,
    changespeakertype,
    changelighttype,
    onchangerele,
    serialnumber,
    editdata,
    getdata,
    loading,
    setFormattedNumber,
    environmentvalue,
    useTypevalue,
    testTypevalues,
    protocolvalues,
    healthrulesvalue,
    connectionType,
    speakertypevalue,
    lighttypevalue,
    relestatusvalue,
    handledoneedit,
    handlepriceChange,
    formattedNumber,
  } = useStateContext();

  
  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    const id = urlParams.get("id");
    getdata(id);
    document.title = "ویرایش مدل ";
  }, []);

 
  return (
    <div className="pb-7.5px">
      <Navbar titles={["دستگاه‌ها", "فهرست مدل‌ها", "ویرایش مدل "]} />
      {loading ? (
        <Loading height={"h-80"} />
      ) : (
        <div
          className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px  "
          dir="rtl">
          <div className="flex flex-row justify-between items-center h-10  ">
            <div className="flex flex-row ">
              <Title text={`ویرایش مدل ${serialnumber} `} />
            </div>
            <ButtonT
              text={"برگشت به لیست"}
              path={"/admin/device/models"}
              link={true}
            />
          </div>
          <TitleDetail title={"اطلاعات کلی مدل"} />
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <InputGroup
              placeholder="مانند دما رطوبت"
              label={"نام نمایشی"}
              val={editdata.name}
              icon={false}
              onchange={onchangeInput}
              id={"username"}
              onchangeAble={true}
            />

            <InputGroup
              icon={false}
              label={"پیش نمایش شماره سریال"}
              id={"serialNumber"}
              value={serialnumber}
              placeholder="شماره سری  و شماره اپدیت را وارد کنید"
              onchangeAble={false}
            />
            <NumberInputWithCommas
              formattedNumber={formattedNumber}
              handlepriceChange={handlepriceChange}
              defaultValue={editdata.price}
              setFormattedNumber={setFormattedNumber}
            />
          </div>
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <InputGroup
              placeholder=" مانند CO2-MW"
              label={"نام سری"}
              val={editdata.seri}
              icon={false}
              onchange={onchangeInput}
              id={"seriname"}
              onchangeAble={true}
            />
            <InputGroup
              placeholder="V-05 مانند"
              label={"شماره آپدیت"}
              val={editdata.updateNumber}
              icon={false}
              onchange={onchangeInput}
              id={"updatenumbr"}
              onchangeAble={true}
            />
            <SelectModal
              icon={false}
              label={"محیط سنجش"}
              style={"w-full justify-between"}
              values={environmentvalue}
              onchange={changeenvironment}
              defaultO={editdata.environment}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={false}
              stylebox={"pl-0"}
            />
            <SelectModal
              icon={false}
              label={"نوع استفاده"}
              style={"w-full justify-between"}
              values={useTypevalue}
              onchange={changeuseType}
              defaultO={editdata.useType}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={false}
              stylebox="pl-0"
            />
          </div>
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <SelectModal
              icon={false}
              label={"نوع سنجش"}
              style={"w-full justify-between"}
              values={testTypevalues}
              onchange={changetestType}
              defaultO={editdata.testType}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={false}
              stylebox="pl-0"
            />
            <SelectModal
              icon={false}
              label={"پروتکل اتصال"}
              style={"w-full justify-between"}
              values={protocolvalues}
              onchange={changeprotocol}
              defaultO={editdata.conectionProtocol}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={false}
              stylebox="pl-0"
            />
            <SelectModal
              icon={false}
              label={"قوانین بهداشتی"}
              style={"w-full justify-between"}
              values={healthrulesvalue}
              onchange={changehealthrules}
              defaultO={editdata.HealtRule}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={false}
              stylebox="pl-0"
            />
            <SelectModal
              icon={false}
              label={"نوع اتصال به برق"}
              style={"w-full justify-between"}
              values={connectionType}
              onchange={changeConnection}
              defaultO={editdata.connectionType}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={false}
              stylebox="pl-0"
            />
          </div>
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <SelectModal
              icon={false}
              label={"وضعیت بلندگو"}
              style={"w-full justify-between"}
              values={speakertypevalue}
              onchange={changespeakertype}
              defaultO={editdata.SpeakerStatus}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={false}
              stylebox="pl-0"
            />
            <SelectModal
              icon={false}
              label={"وضعیت چراغ‌ها‌"}
              style={"w-full justify-between"}
              values={lighttypevalue}
              onchange={changelighttype}
              defaultO={editdata.lightstatus}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={false}
              stylebox="pl-0"
            />
            <SelectModal
              icon={false}
              label={"وضعیت رِله"}
              style={"w-full justify-between"}
              values={relestatusvalue}
              onchange={onchangerele}
              defaultO={editdata.releStatus}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={false}
              stylebox="pl-0"
            />
          </div>
          <ParentComponent submit={handledoneedit} text={"ثبت ویرایش مدل"} />
          <Toaster />
        </div>
      )}
    </div>
  );
};

export default ModelEdit;
